import { render, staticRenderFns } from "./VideoCampaign.vue?vue&type=template&id=6916c81c&"
import script from "./VideoCampaign.vue?vue&type=script&lang=ts&"
export * from "./VideoCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCampaign.vue?vue&type=style&index=0&id=6916c81c&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports